import { z } from "zod";
import { BaseOutputSchema } from "./BaseOutput";

export const CreateMagicLinkOutputSchema = BaseOutputSchema.extend({
    magicLinkId: z.string().uuid(),
    expireAt: z.string().datetime(),
});

export type CreateMagicLinkOutput = z.infer<typeof CreateMagicLinkOutputSchema>;

